// extracted by mini-css-extract-plugin
export default {"loading":"_20ZZGCRANGW4q0fdWqltmK","container":"_1K0AtZXI0Ok1SMl65mbscB"};